<template>
  <div>
    <v-list>
      <div class="headline">Inaktive elever på {{classData.name}}</div>
      <v-list-item v-for="profile in
            inactivePersons" :key="profile.id">
        <v-avatar color="grey" size="36" class="mr-2">
          <v-img v-if="profile.photo" :src="profile.photo" :alt="profile.firstName" />
          <span v-else class="white--text subtitle">
            {{profile.firstName | initial
            }}{{ profile.lastName | initial }}
          </span>
        </v-avatar>
        <v-list-item-content>
          <v-list-item-title>
            <router-link :to="`/profil/${profile.id}`">
              {{ profile.firstName }} {{ profile.middleName }}
              {{ profile.lastName }}
            </router-link>
          </v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </v-list>
  </div>
</template>

<script>
import Vue2Filters from "vue2-filters";
export default {
  mixins: [Vue2Filters.mixin],
  props: ["classData"],
  computed: {
    persons() {
      if (!this.classData.id) {
        return null;
      }

      return this.$store.getters.profilesByClass(this.classData.id);
    },
    activePersons: function() {
      if (!this.persons) {
        return null;
      }
      return this.persons.filter(function(p) {
        return p.active;
      });
    },
    inactivePersons: function() {
      if (!this.persons) {
        return null;
      }
      return this.persons.filter(function(p) {
        return p.active === false;
      });
    }
  }
};
</script>

<style lang="scss" scoped></style>
